import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "gh-root" };
const _hoisted_2 = { class: "gh-carousel" };
const _hoisted_3 = { class: "gh-slides" };
const _hoisted_4 = { class: "gh-cap" };
const _hoisted_5 = ["aria-label"];
const _hoisted_6 = ["aria-label"];
const _hoisted_7 = { class: "gh-dots" };
const _hoisted_8 = ["aria-label", "onClick"];
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("span", { id: "brands" }, null, -1);
const _hoisted_10 = {
    class: "gh-brands",
    id: "gh-brands"
};
const _hoisted_11 = { class: "gh-container" };
const _hoisted_12 = ["href"];
const _hoisted_13 = { class: "gh-cap" };
const _hoisted_14 = { class: "gh-go" };
const _hoisted_15 = {
    key: 0,
    class: "gh-notice"
};
const _hoisted_16 = { class: "gh-notice__label" };
const _hoisted_17 = ["innerHTML"];
const _hoisted_18 = ["onClick"];
const _hoisted_19 = {
    class: "gh-modal__box",
    role: "dialog",
    "aria-modal": "true"
};
const _hoisted_20 = ["innerHTML"];
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'GroupHomeApp',
    props: {
        brands: { default: () => [] },
        goLabel: { default: '' },
        noticeLabel: { default: '公告' },
        moreLabel: { default: '看全文' },
        closeLabel: { default: '關閉' },
        prevLabel: { default: '上一張' },
        nextLabel: { default: '下一張' }
    },
    setup(__props) {
        /**
         * 樂多多集團入口首頁（HOME_LAYOUT=group 時的首頁內容）。
         *
         * 資料全部由 HomeView::groupBrands() 在伺服器端算好，透過 blade 的
         * $unicornScript->data('groupHome.props', …) 傳進來，本元件不打任何 API：
         * 品牌開關、名稱／標語語系、背景圖與轉址網址都是後端的事，前端只負責輪播與排版。
         *
         * class 名稱刻意與改成 Vue 之前的 blade 完全一致（gh- 前綴），
         * 樣式仍由 views/front/home/group-home-style.blade.php 提供，不要改名。
         */
        const props = __props;
        const current = ref(0);
        // 公告在卡片裡最多顯示 3 行；真的被截斷的才出現「看全文」，點了用視窗看完整內容，
        // 不在卡片內展開——展開會讓同一列其他卡片跟著拉高、照片裁切跳動。
        const noticeEls = ref({});
        const clamped = ref({});
        const openBrand = ref(null);
        function setNoticeEl(key, el) {
            if (el instanceof HTMLElement) {
                noticeEls.value[key] = el;
            }
        }
        function measureNotices() {
            const result = {};
            for (const [key, el] of Object.entries(noticeEls.value)) {
                result[key] = el.scrollHeight > el.clientHeight + 1;
            }
            clamped.value = result;
        }
        function onKeydown(e) {
            if (e.key === 'Escape') {
                openBrand.value = null;
            }
        }
        let timer;
        // 只剩一個品牌開著（或全關）時不輪播、不顯示箭頭與圓點，否則按了沒反應、計時器空轉
        const canSlide = computed(() => props.brands.length > 1);
        // 欄數跟著開著的品牌數走（最多 4），避免關掉品牌後右邊空一格
        const cols = computed(() => Math.max(1, Math.min(props.brands.length, 4)));
        function go(index) {
            const total = props.brands.length;
            if (total === 0) {
                return;
            }
            current.value = ((index % total) + total) % total;
            restart();
        }
        function restart() {
            stop();
            if (canSlide.value) {
                timer = window.setInterval(() => go(current.value + 1), 4500);
            }
        }
        function stop() {
            if (timer !== undefined) {
                clearInterval(timer);
                timer = undefined;
            }
        }
        onMounted(() => {
            restart();
            measureNotices();
            // 網頁字型晚到會改變行數，載完再量一次
            document.fonts?.ready.then(measureNotices);
            // 視窗寬度變了，卡片欄數與行寬跟著變，要重算哪些公告被截斷
            window.addEventListener('resize', measureNotices);
            window.addEventListener('keydown', onKeydown);
        });
        onBeforeUnmount(() => {
            stop();
            window.removeEventListener('resize', measureNotices);
            window.removeEventListener('keydown', onKeydown);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("section", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brands, (brand, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: brand.key,
                                class: _normalizeClass(["gh-slide", { 'is-active': i === current.value }]),
                                style: _normalizeStyle({ backgroundImage: brand.bg })
                            }, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("h2", null, _toDisplayString(brand.name), 1),
                                    _createElementVNode("p", null, _toDisplayString(brand.tag), 1)
                                ])
                            ], 6));
                        }), 128))
                    ]),
                    (canSlide.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "gh-navbtn gh-prev",
                                "aria-label": _ctx.prevLabel,
                                onClick: _cache[0] || (_cache[0] = ($event) => (go(current.value - 1)))
                            }, "‹", 8, _hoisted_5),
                            _createElementVNode("button", {
                                type: "button",
                                class: "gh-navbtn gh-next",
                                "aria-label": _ctx.nextLabel,
                                onClick: _cache[1] || (_cache[1] = ($event) => (go(current.value + 1)))
                            }, "›", 8, _hoisted_6),
                            _createElementVNode("div", _hoisted_7, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brands, (brand, i) => {
                                    return (_openBlock(), _createElementBlock("button", {
                                        key: brand.key,
                                        type: "button",
                                        class: _normalizeClass({ 'is-on': i === current.value }),
                                        "aria-label": brand.name,
                                        onClick: ($event) => (go(i))
                                    }, null, 10, _hoisted_8));
                                }), 128))
                            ])
                        ], 64))
                        : _createCommentVNode("", true)
                ]),
                _hoisted_9,
                _createElementVNode("section", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", {
                            class: "gh-grid",
                            style: _normalizeStyle({ '--gh-cols': cols.value })
                        }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brands, (brand) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: brand.key,
                                    class: "gh-card"
                                }, [
                                    _createElementVNode("a", {
                                        class: "gh-photo",
                                        href: brand.href,
                                        style: _normalizeStyle({ backgroundImage: brand.bg })
                                    }, [
                                        _createElementVNode("div", _hoisted_13, [
                                            _createElementVNode("h3", null, _toDisplayString(brand.name), 1),
                                            _createElementVNode("p", null, _toDisplayString(brand.tag), 1),
                                            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.goLabel) + " →", 1)
                                        ])
                                    ], 12, _hoisted_12),
                                    (brand.notice)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.noticeLabel), 1),
                                            _createElementVNode("div", {
                                                ref_for: true,
                                                ref: (el) => setNoticeEl(brand.key, el),
                                                class: "gh-notice__text",
                                                innerHTML: brand.notice
                                            }, null, 8, _hoisted_17),
                                            (clamped.value[brand.key])
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    type: "button",
                                                    class: "gh-notice__more",
                                                    onClick: ($event) => (openBrand.value = brand)
                                                }, _toDisplayString(_ctx.moreLabel) + " › ", 9, _hoisted_18))
                                                : _createCommentVNode("", true)
                                        ]))
                                        : _createCommentVNode("", true)
                                ]));
                            }), 128))
                        ], 4)
                    ])
                ]),
                (openBrand.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "gh-modal",
                        onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (openBrand.value = null), ["self"]))
                    }, [
                        _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("h4", null, _toDisplayString(openBrand.value.name) + "　" + _toDisplayString(_ctx.noticeLabel), 1),
                            _createElementVNode("div", {
                                innerHTML: openBrand.value.notice
                            }, null, 8, _hoisted_20),
                            _createElementVNode("button", {
                                type: "button",
                                class: "gh-modal__close",
                                onClick: _cache[2] || (_cache[2] = ($event) => (openBrand.value = null))
                            }, _toDisplayString(_ctx.closeLabel), 1)
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
